import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WorkEnvironmentSections from '../../../../../constants/WorkEnvironmentSections';
import Quadrant from '../../../../../components/WorkEnvironment/components/Quadrant';
import style from './style/workenvironmentattachment.scss';

export default class WorkEnvironmentAttachment extends Component {

    /**
     * getParticipantLanguage
     * converts language id to a shorthand notation that is used to import child components
     */
    getParticipantLanguage(participantLanguage) {
        return participantLanguage.slice(0,2).toLowerCase();
    }

    render() {
        const { content, participantLanguage } = this.props;

        if (!content || !participantLanguage) {
            return null;
        }

        const language = this.getParticipantLanguage(participantLanguage);

        return (
            <section className={ style.work_environment_detail_attachment_wrapper }>
                <p className={ style.work_environment_module_definition } dangerouslySetInnerHTML={{ __html: content.definition }}/>
                <section>
                    <Quadrant score={content.scores.filter(score => score.handle === WorkEnvironmentSections.MANAGER)[0]} language={language}/>
                    <Quadrant score={content.scores.filter(score => score.handle === WorkEnvironmentSections.TEAM)[0]} language={language}/>
                    <Quadrant score={content.scores.filter(score => score.handle === WorkEnvironmentSections.ORGANISATION)[0]} language={language}/>
                </section>
            </section>
        );
    }
}

WorkEnvironmentAttachment.propTypes = {
    participantLanguage: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired
};
